import {
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
  useTheme,
  capitalize,
  useMediaQuery,
  Drawer
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import Activity from './component/Activity';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { useMemo, useState } from 'react';
import { IProject } from 'src/models/users';
import MenuIcon from '@mui/icons-material/Menu';
import React from 'react';
import { toogleSidebar } from 'src/features/sidebarToggleSlice';
import { MainContent } from '../../Sidebar';
import ProjectListDialog from 'src/components/DialogProjectList';
import moment from 'moment';
import useObjectManagement from 'src/services/useObjectManagement';

interface Item {
  name: string;
}

interface ICustomBox {
  isOnTour: boolean;
}

const CustomBox = styled(Box)<ICustomBox>(
  ({ theme, isOnTour }) => `
    max-width: 100vw;
    padding: ${theme.spacing(2, 4)};
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    ${!isOnTour && 'z-index: 6;'}
    overflow: hidden;
    background: ${theme.header.background}
`
);

function TopHeader() {
  const theme = useTheme();
  // const posthog = usePostHog();
  const project = useAppSelector((state) => state.users.project);
  const projectList = useAppSelector(
    (state) => state.users.userProfile.data.projectList
  );
  const { useGetLastUpdatedData } = useObjectManagement();

  const { data: lastUpdatedData } = useGetLastUpdatedData({
    variables: { projectId: project.id },
    skip: !project.id
  });

  const { isOnTour } = useAppSelector((state) => state.storeProductTour);

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const addName = useMemo((): Array<IProject & Item> => {
    if (!projectList) return [];

    return projectList?.map((object) => ({
      ...object,
      name: object.displayName
    })) as Array<IProject & Item>;
  }, [projectList]);

  //responsive sidebar
  const dispatch = useAppDispatch();
  const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const matchesUpSm = useMediaQuery(theme.breakpoints.up('sm'));

  const sidebarToggle = useAppSelector((state) => state.sidebarToggle.toggle);
  const toggleSidebar = () => {
    dispatch(toogleSidebar(!sidebarToggle));
  };

  React.useEffect(() => {
    if (matchesUpMd) {
      dispatch(toogleSidebar(true));
      return;
    }
    dispatch(toogleSidebar(false));
    return;
  }, [matchesUpMd]);

  return (
    <CustomBox sx={{ ...(!matchesUpMd && { padding: 1 }) }} isOnTour={isOnTour}>
      <Stack direction="row" alignItems="center" spacing={2}>
        {!matchesUpMd && (
          <IconButton onClick={toggleSidebar} aria-label="open drawer">
            <MenuIcon />
          </IconButton>
        )}
        {!matchesUpMd && (
          <Drawer open={sidebarToggle} onClose={toggleSidebar}>
            <MainContent open={sidebarToggle} toggleSidebar={toggleSidebar} />
          </Drawer>
        )}
        <Typography variant="h3" fontSize={{ xs: 14, md: 22 }}>
          {!matchesUpSm && project?.displayName.length > 20
            ? `${capitalize(project.displayName).slice(0, 20)}...`
            : capitalize(project.displayName)}
        </Typography>
        {projectList.length > 1 && (
          <Button
            onClick={handleClickOpen}
            size="small"
            variant="outlined"
            sx={{
              height: theme.spacing(3.2),
              ml: theme.spacing(2),
              fontWeight: 600,
              background: '#FBFBFB',
              border: '1px solid rgba(5, 28, 38, 0.08)'
            }}
            endIcon={<AutorenewIcon />}
          >
            Switch
          </Button>
        )}
      </Stack>
      <Stack direction="row" gap={2}>
        {/* <Stack>
          <Typography variant="caption">Last Data Updated:</Typography>
          <Typography variant="body2">
            {lastUpdatedData?.objectManagement_getLastDataUpdate
              ? moment(
                  lastUpdatedData.objectManagement_getLastDataUpdate
                ).format('DD MMM YYYY, HH:mm')
              : '-'}
          </Typography>
        </Stack> */}
        <Activity />
      </Stack>
      <ProjectListDialog
        open={open}
        onClose={handleClose}
        project={project}
        projectList={projectList}
      />
    </CustomBox>
  );
}

export default TopHeader;
